export function hasMod(names) {
  const pack = JSON.parse(window.localStorage.getItem('team4care_pack'));
  if (!pack) return true;
  let result = false;
  names.forEach(n => {
    let regex = new RegExp(n, "ig");
    result = result || pack.find(l => regex.test(l.code));
  });
  return result;
}